import { Navigate, Route, Routes } from 'react-router-dom';
import App from './App.tsx';
import { useUser } from './context/User/useUser.tsx';
import { isAdmin } from './helpers/user.ts';
import './index.css';
import AdminProjects from './pages/Admin/Projects/Projects.tsx';
import UserProjects from './pages/Admin/UserProjects/UserProjects.tsx';
import Users from './pages/Admin/Users/Users.tsx';
import ExportProject from './pages/ExportProject/ExportProject.tsx';
import Login from './pages/Login/Login.tsx';
import Projects from './pages/Projects/Projects.tsx';
import SignUp from './pages/SignUp/SignUp.tsx';
import CancelPage from './pages/Subscription/Cancel.tsx';
import SubscriptionSuccess from './pages/Subscription/Success.tsx';
import UserSettings from './pages/UserSettings/UserSettings.tsx';

const AdminRoute = ({ children }: { children: React.ReactElement }) => {
  const user = useUser();

  if (user.isAuthenticated && !isAdmin(user)) {
    return <Navigate to="/" />;
  }

  return children;
};

export const BaseRoutes = () => {
  return (
    <Routes>
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:projectId" element={<App />} />
      <Route path="/projects/export/:projectId" element={<ExportProject />} />
      <Route path="/" element={<Projects />} />
      <Route path="/app" element={<App />} />
      <Route path="/sign-in" element={<Login />} />
      <Route path="/sign-up" element={<SignUp />} />

      <Route path="/settings" element={<UserSettings />} />
      <Route path="/success" element={<SubscriptionSuccess />} />
      <Route path="/cancel" element={<CancelPage />} />
      <Route
        path="/admin/projects"
        element={
          <AdminRoute>
            <AdminProjects />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <AdminRoute>
            <Users />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/users/:userId/projects"
        element={
          <AdminRoute>
            <UserProjects />
          </AdminRoute>
        }
      />
    </Routes>
  );
};
